import Vue from 'vue';
import Vuex from 'vuex';
import quiz from '@/store/quiz';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    isLogin: false,
    isGetUser: false,
    studyCampDetail: null,
    isShowPop: false,
    planIds: '',
    isJoinBtn: false, // 是否是点击参加进入的活动弹窗
    isExtraMonth: false,
    schoolInfo: null,
  },
  mutations: {
    SET_USER_INFO(state, payload: any) {
      state.userInfo = payload;
    },
    SET_LOGIN_STATUS(state, payload: any) {
      state.isLogin = payload;
    },
    SET_IS_USER_STATUS(state, payload: any) {
      state.isGetUser = payload;
    },
    // 设置学习营详情
    SET_STUDY_CAMP_DETAIL(state, payload: any) {
      state.studyCampDetail = payload;
    },
    // 设置学习营详情
    SET_SHOW_POP(state, payload: any) {
      state.isShowPop = payload;
    },
    // 设置学习营id
    SET_PLAN_IDS(state, payload: any) {
      state.planIds = payload;
    },
    // 设置活动产品弹框来源
    SET_JOIN_BTN(state, payload: any) {
      state.isJoinBtn = payload;
    },
    SET_IsExtraMonth(state, payload: any) {
      state.isExtraMonth = payload;
    },
    SET_SCHOOL_INFO(state, payload: any) {
      state.schoolInfo = payload;
    },
  },
  actions: {
    setUserInfo(context, userInfo: any) {
      context.commit('SET_USER_INFO', userInfo);
    },
    setLoginStatus(context, status: boolean) {
      context.commit('SET_LOGIN_STATUS', status);
    },
    setIsUserStatus(context, status: boolean) {
      context.commit('SET_IS_USER_STATUS', status);
    },
    setStudyCampDetail(context, status: boolean) {
      context.commit('SET_STUDY_CAMP_DETAIL', status);
    },
  },
  modules: {
    quiz,
  },
});
